"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
}); // tslint:disable-next-line:no-var-requires

var Parser = require('jsonparse');

var stream_1 = require("stream");

var EntryHandlerArrayValue_1 = require("./entryhandler/EntryHandlerArrayValue");

var EntryHandlerContainer_1 = require("./entryhandler/EntryHandlerContainer");

var EntryHandlerInvalidFallback_1 = require("./entryhandler/EntryHandlerInvalidFallback");

var EntryHandlerPredicate_1 = require("./entryhandler/EntryHandlerPredicate");

var EntryHandlerKeywordContext_1 = require("./entryhandler/keyword/EntryHandlerKeywordContext");

var EntryHandlerKeywordGraph_1 = require("./entryhandler/keyword/EntryHandlerKeywordGraph");

var EntryHandlerKeywordId_1 = require("./entryhandler/keyword/EntryHandlerKeywordId");

var EntryHandlerKeywordType_1 = require("./entryhandler/keyword/EntryHandlerKeywordType");

var EntryHandlerKeywordUnknownFallback_1 = require("./entryhandler/keyword/EntryHandlerKeywordUnknownFallback");

var EntryHandlerKeywordValue_1 = require("./entryhandler/keyword/EntryHandlerKeywordValue");

var ParsingContext_1 = require("./ParsingContext");

var Util_1 = require("./Util");
/**
 * A stream transformer that parses JSON-LD (text) streams to an {@link RDF.Stream}.
 */


var JsonLdParser =
/*#__PURE__*/
function (_stream_1$Transform) {
  _inherits(JsonLdParser, _stream_1$Transform);

  function JsonLdParser(options) {
    var _this;

    _classCallCheck(this, JsonLdParser);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(JsonLdParser).call(this, {
      objectMode: true
    }));
    options = options || {};
    _this.options = options;
    _this.parsingContext = new ParsingContext_1.ParsingContext(Object.assign({
      parser: _assertThisInitialized(_this)
    }, options));
    _this.util = new Util_1.Util({
      dataFactory: options.dataFactory,
      parsingContext: _this.parsingContext
    });
    _this.jsonParser = new Parser();
    _this.contextAwaitingJobs = [];
    _this.contextJobs = [];
    _this.lastDepth = 0;
    _this.lastOnValueJob = Promise.resolve();

    _this.attachJsonParserListeners();

    return _this;
  }
  /**
   * Parses the given text stream into a quad stream.
   * @param {NodeJS.EventEmitter} stream A text stream.
   * @return {NodeJS.EventEmitter} A quad stream.
   */


  _createClass(JsonLdParser, [{
    key: "import",
    value: function _import(stream) {
      var output = new stream_1.PassThrough({
        objectMode: true
      });
      stream.on('error', function (error) {
        return parsed.emit('error', error);
      });
      stream.on('data', function (data) {
        return output.write(data);
      });
      stream.on('end', function () {
        return output.emit('end');
      });
      var parsed = output.pipe(new JsonLdParser(this.options));
      return parsed;
    }
  }, {
    key: "_transform",
    value: function _transform(chunk, encoding, callback) {
      this.jsonParser.write(chunk);
      this.lastOnValueJob.then(function () {
        return callback();
      }, function (error) {
        return callback(error);
      });
    }
    /**
     * Start a new job for parsing the given value.
     *
     * This will let the first valid {@link IEntryHandler} handle the entry.
     *
     * @param {any[]} keys The stack of keys.
     * @param value The value to parse.
     * @param {number} depth The depth to parse at.
     * @return {Promise<void>} A promise resolving when the job is done.
     */

  }, {
    key: "newOnValueJob",
    value: function () {
      var _newOnValueJob = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(keys, value, depth) {
        var listPointer, key, parentKey, handleKey, inProperty, i, validationResult, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, entryHandler, testResult;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(depth < this.lastDepth)) {
                  _context.next = 5;
                  break;
                }

                // Check if we had any RDF lists that need to be terminated with an rdf:nil
                listPointer = this.parsingContext.listPointerStack[this.lastDepth];

                if (listPointer) {
                  if (listPointer.term) {
                    this.emit('data', this.util.dataFactory.quad(listPointer.term, this.util.rdfRest, this.util.rdfNil, this.util.getDefaultGraph()));
                  } else {
                    this.parsingContext.getUnidentifiedValueBufferSafe(listPointer.listRootDepth).push({
                      predicate: listPointer.initialPredicate,
                      object: this.util.rdfNil,
                      reverse: false
                    });
                  }

                  this.parsingContext.listPointerStack.splice(this.lastDepth, 1);
                } // Flush the buffer for lastDepth


                _context.next = 5;
                return this.flushBuffer(this.lastDepth, keys);

              case 5:
                _context.next = 7;
                return this.util.unaliasKeyword(keys[depth], keys, depth);

              case 7:
                key = _context.sent;
                _context.next = 10;
                return this.util.unaliasKeywordParent(keys, depth);

              case 10:
                parentKey = _context.sent;
                this.parsingContext.emittedStack[depth] = true;
                handleKey = true; // Keywords inside @reverse is not allowed

                if (Util_1.Util.isKeyword(key) && parentKey === '@reverse') {
                  this.emit('error', new Error("Found the @id '".concat(value, "' inside an @reverse property")));
                } // Skip further processing if one of the parent nodes are invalid.
                // We use the validationStack to reuse validation results that were produced before with common key stacks.


                inProperty = false;

                if (this.parsingContext.validationStack.length > 1) {
                  inProperty = this.parsingContext.validationStack[this.parsingContext.validationStack.length - 1].property;
                }

                i = Math.max(1, this.parsingContext.validationStack.length - 1);

              case 17:
                if (!(i < keys.length - 1)) {
                  _context.next = 34;
                  break;
                }

                _context.t0 = this.parsingContext.validationStack[i];

                if (_context.t0) {
                  _context.next = 23;
                  break;
                }

                _context.next = 22;
                return this.validateKey(keys.slice(0, i + 1), i, inProperty);

              case 22:
                _context.t0 = this.parsingContext.validationStack[i] = _context.sent;

              case 23:
                validationResult = _context.t0;

                if (validationResult.valid) {
                  _context.next = 30;
                  break;
                }

                this.parsingContext.emittedStack[depth] = false;
                handleKey = false;
                return _context.abrupt("break", 34);

              case 30:
                if (!inProperty && validationResult.property) {
                  inProperty = true;
                }

              case 31:
                i++;
                _context.next = 17;
                break;

              case 34:
                // Skip further processing if this node is part of a literal
                if (this.util.isLiteral(depth)) {
                  handleKey = false;
                } // Get handler


                if (!handleKey) {
                  _context.next = 68;
                  break;
                }

                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 39;
                _iterator = JsonLdParser.ENTRY_HANDLERS[Symbol.iterator]();

              case 41:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 53;
                  break;
                }

                entryHandler = _step.value;
                _context.next = 45;
                return entryHandler.test(this.parsingContext, this.util, key, keys, depth);

              case 45:
                testResult = _context.sent;

                if (!testResult) {
                  _context.next = 50;
                  break;
                }

                _context.next = 49;
                return entryHandler.handle(this.parsingContext, this.util, key, keys, value, depth, testResult);

              case 49:
                return _context.abrupt("break", 53);

              case 50:
                _iteratorNormalCompletion = true;
                _context.next = 41;
                break;

              case 53:
                _context.next = 59;
                break;

              case 55:
                _context.prev = 55;
                _context.t1 = _context["catch"](39);
                _didIteratorError = true;
                _iteratorError = _context.t1;

              case 59:
                _context.prev = 59;
                _context.prev = 60;

                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }

              case 62:
                _context.prev = 62;

                if (!_didIteratorError) {
                  _context.next = 65;
                  break;
                }

                throw _iteratorError;

              case 65:
                return _context.finish(62);

              case 66:
                return _context.finish(59);

              case 67:
                // Flag that this depth is processed
                this.parsingContext.processingStack[depth] = true;

              case 68:
                if (!(depth === 0 && Array.isArray(value))) {
                  _context.next = 71;
                  break;
                }

                _context.next = 71;
                return this.util.validateValueIndexes(value);

              case 71:
                // When we go up the stack, flush the old stack
                if (depth < this.lastDepth) {
                  // Reset our stack
                  this.parsingContext.processingStack.splice(this.lastDepth, 1);
                  this.parsingContext.emittedStack.splice(this.lastDepth, 1);
                  this.parsingContext.idStack.splice(this.lastDepth, 1);
                  this.parsingContext.graphStack.splice(this.lastDepth + 1, 1);
                  this.parsingContext.literalStack.splice(this.lastDepth, 1);
                  this.parsingContext.validationStack.splice(this.lastDepth - 1, 2);
                }

                this.lastDepth = depth; // Clear the keyword cache at this depth, and everything underneath.

                this.parsingContext.unaliasedKeywordCacheStack.splice(depth - 1);

              case 74:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[39, 55, 59, 67], [60,, 62, 66]]);
      }));

      function newOnValueJob(_x, _x2, _x3) {
        return _newOnValueJob.apply(this, arguments);
      }

      return newOnValueJob;
    }()
    /**
     * Check if at least one {@link IEntryHandler} validates the entry to true.
     * @param {any[]} keys A stack of keys.
     * @param {number} depth A depth.
     * @param {boolean} inProperty If the current depth is part of a valid property node.
     * @return {Promise<{ valid: boolean, property: boolean }>} A promise resolving to true or false.
     */

  }, {
    key: "validateKey",
    value: function () {
      var _validateKey = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(keys, depth, inProperty) {
        var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, entryHandler;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context2.prev = 3;
                _iterator2 = JsonLdParser.ENTRY_HANDLERS[Symbol.iterator]();

              case 5:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context2.next = 14;
                  break;
                }

                entryHandler = _step2.value;
                _context2.next = 9;
                return entryHandler.validate(this.parsingContext, this.util, keys, depth, inProperty);

              case 9:
                if (!_context2.sent) {
                  _context2.next = 11;
                  break;
                }

                return _context2.abrupt("return", {
                  valid: true,
                  property: inProperty || entryHandler.isPropertyHandler()
                });

              case 11:
                _iteratorNormalCompletion2 = true;
                _context2.next = 5;
                break;

              case 14:
                _context2.next = 20;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2["catch"](3);
                _didIteratorError2 = true;
                _iteratorError2 = _context2.t0;

              case 20:
                _context2.prev = 20;
                _context2.prev = 21;

                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                  _iterator2.return();
                }

              case 23:
                _context2.prev = 23;

                if (!_didIteratorError2) {
                  _context2.next = 26;
                  break;
                }

                throw _iteratorError2;

              case 26:
                return _context2.finish(23);

              case 27:
                return _context2.finish(20);

              case 28:
                return _context2.abrupt("return", {
                  valid: false,
                  property: false
                });

              case 29:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 16, 20, 28], [21,, 23, 27]]);
      }));

      function validateKey(_x4, _x5, _x6) {
        return _validateKey.apply(this, arguments);
      }

      return validateKey;
    }()
    /**
     * Attach all required listeners to the JSON parser.
     *
     * This should only be called once.
     */

  }, {
    key: "attachJsonParserListeners",
    value: function attachJsonParserListeners() {
      var _this2 = this;

      // Listen to json parser events
      this.jsonParser.onValue = function (value) {
        var depth = _this2.jsonParser.stack.length;
        var keys = new Array(depth + 1).fill(0).map(function (v, i) {
          return i === depth ? _this2.jsonParser.key : _this2.jsonParser.stack[i].key;
        });

        if (!_this2.isParsingContextInner(depth)) {
          // Don't parse inner nodes inside @context
          var valueJobCb = function valueJobCb() {
            return _this2.newOnValueJob(keys, value, depth);
          };

          if (_this2.parsingContext.allowOutOfOrderContext && !_this2.parsingContext.contextTree.getContext(keys.slice(0, -1))) {
            // If an out-of-order context is allowed,
            // we have to buffer everything.
            // We store jobs for @context's separately,
            // because at the end, we have to process them first.
            if (keys[depth] === '@context') {
              var jobs = _this2.contextJobs[depth];

              if (!jobs) {
                jobs = _this2.contextJobs[depth] = [];
              }

              jobs.push(valueJobCb);
            } else {
              _this2.contextAwaitingJobs.push(valueJobCb);
            }
          } else {
            // Make sure that our value jobs are chained synchronously
            _this2.lastOnValueJob = _this2.lastOnValueJob.then(valueJobCb);
          } // Execute all buffered jobs on deeper levels


          if (_this2.parsingContext.allowOutOfOrderContext && depth === 0) {
            _this2.lastOnValueJob = _this2.lastOnValueJob.then(function () {
              return _this2.executeBufferedJobs();
            });
          }
        }
      };

      this.jsonParser.onError = function (error) {
        _this2.emit('error', error);
      };
    }
    /**
     * Check if the parser is currently parsing an element that is part of an @context entry.
     * @param {number} depth A depth.
     * @return {boolean} A boolean.
     */

  }, {
    key: "isParsingContextInner",
    value: function isParsingContextInner(depth) {
      for (var i = depth; i > 0; i--) {
        if (this.jsonParser.stack[i - 1].key === '@context') {
          return true;
        }
      }

      return false;
    }
    /**
     * Execute all buffered jobs.
     * @return {Promise<void>} A promise resolving if all jobs are finished.
     */

  }, {
    key: "executeBufferedJobs",
    value: function () {
      var _executeBufferedJobs = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, jobs, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, job, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, _job;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // Handle context jobs
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context3.prev = 3;
                _iterator3 = this.contextJobs[Symbol.iterator]();

              case 5:
                if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                  _context3.next = 37;
                  break;
                }

                jobs = _step3.value;

                if (!jobs) {
                  _context3.next = 34;
                  break;
                }

                _iteratorNormalCompletion5 = true;
                _didIteratorError5 = false;
                _iteratorError5 = undefined;
                _context3.prev = 11;
                _iterator5 = jobs[Symbol.iterator]();

              case 13:
                if (_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done) {
                  _context3.next = 20;
                  break;
                }

                job = _step5.value;
                _context3.next = 17;
                return job();

              case 17:
                _iteratorNormalCompletion5 = true;
                _context3.next = 13;
                break;

              case 20:
                _context3.next = 26;
                break;

              case 22:
                _context3.prev = 22;
                _context3.t0 = _context3["catch"](11);
                _didIteratorError5 = true;
                _iteratorError5 = _context3.t0;

              case 26:
                _context3.prev = 26;
                _context3.prev = 27;

                if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
                  _iterator5.return();
                }

              case 29:
                _context3.prev = 29;

                if (!_didIteratorError5) {
                  _context3.next = 32;
                  break;
                }

                throw _iteratorError5;

              case 32:
                return _context3.finish(29);

              case 33:
                return _context3.finish(26);

              case 34:
                _iteratorNormalCompletion3 = true;
                _context3.next = 5;
                break;

              case 37:
                _context3.next = 43;
                break;

              case 39:
                _context3.prev = 39;
                _context3.t1 = _context3["catch"](3);
                _didIteratorError3 = true;
                _iteratorError3 = _context3.t1;

              case 43:
                _context3.prev = 43;
                _context3.prev = 44;

                if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                  _iterator3.return();
                }

              case 46:
                _context3.prev = 46;

                if (!_didIteratorError3) {
                  _context3.next = 49;
                  break;
                }

                throw _iteratorError3;

              case 49:
                return _context3.finish(46);

              case 50:
                return _context3.finish(43);

              case 51:
                // Handle non-context jobs
                _iteratorNormalCompletion4 = true;
                _didIteratorError4 = false;
                _iteratorError4 = undefined;
                _context3.prev = 54;
                _iterator4 = this.contextAwaitingJobs[Symbol.iterator]();

              case 56:
                if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                  _context3.next = 63;
                  break;
                }

                _job = _step4.value;
                _context3.next = 60;
                return _job();

              case 60:
                _iteratorNormalCompletion4 = true;
                _context3.next = 56;
                break;

              case 63:
                _context3.next = 69;
                break;

              case 65:
                _context3.prev = 65;
                _context3.t2 = _context3["catch"](54);
                _didIteratorError4 = true;
                _iteratorError4 = _context3.t2;

              case 69:
                _context3.prev = 69;
                _context3.prev = 70;

                if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                  _iterator4.return();
                }

              case 72:
                _context3.prev = 72;

                if (!_didIteratorError4) {
                  _context3.next = 75;
                  break;
                }

                throw _iteratorError4;

              case 75:
                return _context3.finish(72);

              case 76:
                return _context3.finish(69);

              case 77:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 39, 43, 51], [11, 22, 26, 34], [27,, 29, 33], [44,, 46, 50], [54, 65, 69, 77], [70,, 72, 76]]);
      }));

      function executeBufferedJobs() {
        return _executeBufferedJobs.apply(this, arguments);
      }

      return executeBufferedJobs;
    }()
    /**
     * Flush buffers for the given depth.
     *
     * This should be called after the last entry at a given depth was processed.
     *
     * @param {number} depth A depth.
     * @param {any[]} keys A stack of keys.
     * @return {Promise<void>} A promise resolving if flushing is done.
     */

  }, {
    key: "flushBuffer",
    value: function () {
      var _flushBuffer = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(depth, keys) {
        var subject, valueBuffer, depthOffsetGraph, graph, _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, bufferedValue, subGraphBuffer, _iteratorNormalCompletion7, _didIteratorError7, _iteratorError7, _iterator7, _step7, _bufferedValue, graphBuffer, _graph, _iteratorNormalCompletion8, _didIteratorError8, _iteratorError8, _iterator8, _step8, _bufferedValue2;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                subject = this.parsingContext.idStack[depth];

                if (subject === undefined) {
                  subject = this.parsingContext.idStack[depth] = this.util.dataFactory.blankNode();
                } // Flush values at this level


                valueBuffer = this.parsingContext.unidentifiedValuesBuffer[depth];

                if (!valueBuffer) {
                  _context4.next = 61;
                  break;
                }

                if (!subject) {
                  _context4.next = 59;
                  break;
                }

                _context4.next = 7;
                return this.util.getDepthOffsetGraph(depth, keys);

              case 7:
                depthOffsetGraph = _context4.sent;
                graph = this.parsingContext.graphStack[depth] || depthOffsetGraph >= 0 ? this.parsingContext.idStack[depth - depthOffsetGraph - 1] : this.util.getDefaultGraph();

                if (!graph) {
                  _context4.next = 32;
                  break;
                }

                // Flush values to stream if the graph @id is known
                this.parsingContext.emittedStack[depth] = true;
                _iteratorNormalCompletion6 = true;
                _didIteratorError6 = false;
                _iteratorError6 = undefined;
                _context4.prev = 14;

                for (_iterator6 = valueBuffer[Symbol.iterator](); !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                  bufferedValue = _step6.value;

                  if (bufferedValue.reverse) {
                    this.parsingContext.emitQuad(depth, this.util.dataFactory.quad(bufferedValue.object, bufferedValue.predicate, subject, graph));
                  } else {
                    this.parsingContext.emitQuad(depth, this.util.dataFactory.quad(subject, bufferedValue.predicate, bufferedValue.object, graph));
                  }
                }

                _context4.next = 22;
                break;

              case 18:
                _context4.prev = 18;
                _context4.t0 = _context4["catch"](14);
                _didIteratorError6 = true;
                _iteratorError6 = _context4.t0;

              case 22:
                _context4.prev = 22;
                _context4.prev = 23;

                if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
                  _iterator6.return();
                }

              case 25:
                _context4.prev = 25;

                if (!_didIteratorError6) {
                  _context4.next = 28;
                  break;
                }

                throw _iteratorError6;

              case 28:
                return _context4.finish(25);

              case 29:
                return _context4.finish(22);

              case 30:
                _context4.next = 59;
                break;

              case 32:
                _context4.t1 = this.parsingContext;
                _context4.t2 = depth;
                _context4.next = 36;
                return this.util.getDepthOffsetGraph(depth, keys);

              case 36:
                _context4.t3 = _context4.sent;
                _context4.t4 = _context4.t2 - _context4.t3;
                _context4.t5 = _context4.t4 - 1;
                subGraphBuffer = _context4.t1.getUnidentifiedGraphBufferSafe.call(_context4.t1, _context4.t5);
                _iteratorNormalCompletion7 = true;
                _didIteratorError7 = false;
                _iteratorError7 = undefined;
                _context4.prev = 43;

                for (_iterator7 = valueBuffer[Symbol.iterator](); !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                  _bufferedValue = _step7.value;

                  if (_bufferedValue.reverse) {
                    subGraphBuffer.push({
                      object: subject,
                      predicate: _bufferedValue.predicate,
                      subject: _bufferedValue.object
                    });
                  } else {
                    subGraphBuffer.push({
                      object: _bufferedValue.object,
                      predicate: _bufferedValue.predicate,
                      subject: subject
                    });
                  }
                }

                _context4.next = 51;
                break;

              case 47:
                _context4.prev = 47;
                _context4.t6 = _context4["catch"](43);
                _didIteratorError7 = true;
                _iteratorError7 = _context4.t6;

              case 51:
                _context4.prev = 51;
                _context4.prev = 52;

                if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
                  _iterator7.return();
                }

              case 54:
                _context4.prev = 54;

                if (!_didIteratorError7) {
                  _context4.next = 57;
                  break;
                }

                throw _iteratorError7;

              case 57:
                return _context4.finish(54);

              case 58:
                return _context4.finish(51);

              case 59:
                this.parsingContext.unidentifiedValuesBuffer.splice(depth, 1);
                this.parsingContext.literalStack.splice(depth, 1);

              case 61:
                // Flush graphs at this level
                graphBuffer = this.parsingContext.unidentifiedGraphsBuffer[depth];

                if (!graphBuffer) {
                  _context4.next = 86;
                  break;
                }

                if (!subject) {
                  _context4.next = 85;
                  break;
                }

                // A @graph statement at the root without @id relates to the default graph,
                // unless there are top-level properties,
                // others relate to blank nodes.
                _graph = depth === 1 && subject.termType === 'BlankNode' && !this.parsingContext.topLevelProperties ? this.util.getDefaultGraph() : subject;
                this.parsingContext.emittedStack[depth] = true;
                _iteratorNormalCompletion8 = true;
                _didIteratorError8 = false;
                _iteratorError8 = undefined;
                _context4.prev = 69;

                for (_iterator8 = graphBuffer[Symbol.iterator](); !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                  _bufferedValue2 = _step8.value;
                  this.parsingContext.emitQuad(depth, this.util.dataFactory.quad(_bufferedValue2.subject, _bufferedValue2.predicate, _bufferedValue2.object, _graph));
                }

                _context4.next = 77;
                break;

              case 73:
                _context4.prev = 73;
                _context4.t7 = _context4["catch"](69);
                _didIteratorError8 = true;
                _iteratorError8 = _context4.t7;

              case 77:
                _context4.prev = 77;
                _context4.prev = 78;

                if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
                  _iterator8.return();
                }

              case 80:
                _context4.prev = 80;

                if (!_didIteratorError8) {
                  _context4.next = 83;
                  break;
                }

                throw _iteratorError8;

              case 83:
                return _context4.finish(80);

              case 84:
                return _context4.finish(77);

              case 85:
                this.parsingContext.unidentifiedGraphsBuffer.splice(depth, 1);

              case 86:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[14, 18, 22, 30], [23,, 25, 29], [43, 47, 51, 59], [52,, 54, 58], [69, 73, 77, 85], [78,, 80, 84]]);
      }));

      function flushBuffer(_x7, _x8) {
        return _flushBuffer.apply(this, arguments);
      }

      return flushBuffer;
    }()
  }]);

  return JsonLdParser;
}(stream_1.Transform);

JsonLdParser.DEFAULT_PROCESSING_MODE = '1.0';
JsonLdParser.ENTRY_HANDLERS = [new EntryHandlerArrayValue_1.EntryHandlerArrayValue(), new EntryHandlerKeywordContext_1.EntryHandlerKeywordContext(), new EntryHandlerKeywordId_1.EntryHandlerKeywordId(), new EntryHandlerKeywordGraph_1.EntryHandlerKeywordGraph(), new EntryHandlerKeywordType_1.EntryHandlerKeywordType(), new EntryHandlerKeywordValue_1.EntryHandlerKeywordValue(), new EntryHandlerKeywordUnknownFallback_1.EntryHandlerKeywordUnknownFallback(), new EntryHandlerContainer_1.EntryHandlerContainer(), new EntryHandlerPredicate_1.EntryHandlerPredicate(), new EntryHandlerInvalidFallback_1.EntryHandlerInvalidFallback()];
exports.JsonLdParser = JsonLdParser;